import React from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

import { useModal } from '../Modal/ModalContext';
import { useTimeModal } from '../TimeModal/TimeModalContext';

const AllUsersTable = () => {
    const { openModal } = useModal();
    const { openTimeModal } = useTimeModal();
    const [users, setUsers] = React.useState([]);
    const [reload, setReload] = React.useState(true);
    const [warning, setWarning] = React.useState('Загрузка...');

    const [role, setRole] = React.useState('');
    const [userId, setUserId] = React.useState('');

    const [limitForView, setLimitForView] = React.useState(20);
    const [visibilityBtn, setVisibilityBtn] = React.useState(false);

    React.useEffect(() => {
        const token = localStorage.getItem('token');
        axios.get(`/api/users?approval=Активен&limitForView=${limitForView}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then(response => {
            if (response.data.length === 0) {
                setUsers([]);
                setWarning('Пользователи в системе отсутствуют.');
                setVisibilityBtn(false);
            } else {
                setUsers(response.data);
                setWarning('');
                setVisibilityBtn(response.data.length >= limitForView);
            }
        })
        .catch(error => {
            console.error('Ошибка при получении данных:', error);
            setWarning(`Не удалось загрузить таблицу пользователей: ${error.response?.data.message || error.message}`);
        }).finally(() => {
            setReload(false);
        })
    }, [reload]);

    const changeAccess = (userIdForChange) => {
        axios.put(`/api/change-access?userId=${userIdForChange}`)
        .then((response) => {
            setReload(true);
            if (response.data == 'На рассмотрении') {
                openTimeModal('Доступ отозван', 'success');
            } else {
                openTimeModal('Доступ разрешён', 'success');
            }
        })
        .catch(error => {
            console.error('Ошибка при изменении доступа:', error);
            openTimeModal(`Не удалось изменить параметр доступа к системе. ${error.response?.data.message || error.message}`, 'error');
        })
    };

    React.useEffect(() => {
        if (role && userId) {
            axios.put(`/api/change-role?role=${role}&userId=${userId}`)
            .then(() => {
                openTimeModal('Тип учётной записи успешно изменён', 'success');
                setReload(true);
            }).catch(error => {
                console.error('Ошибка при изменении роли:', error);
                openTimeModal(`Не удалось изменить тип учётной записи. ${error.response?.data.message || error.message}`, 'error');
            })
        }
    }, [role, userId]);

    const changeRole = (e, userIdForChangeRole) => {
        setRole(e.target.value); 
        setUserId(userIdForChangeRole);
    };

    const warningChangeStatus = 
    <form style={{textAlign: 'center'}}>
        <h3>Внимание,</h3>
        <a style={{cursor: 'text', fontSize: '16px'}}>В целях безопасности системы вы не можете отозвать доступ у своей учётной записи. Обратитесь к администратору.</a>
    </form>;

    return (
        <>
            <div className='tableContainer'>
                <div className='tableHeader'>
                    <a className='fioUser'>ФИО</a>
                    <a className='emailUser'>Электронная почта</a>
                    <a className='regionUser'>Основной регион деятельности</a>
                    <a className='roleUser'>Тип учетной записи</a>
                    <a className='statusUser'>Действие</a>
                </div>
                {warning ? <div className='case warningLine'><a>{warning}</a></div>
                : users.map((user) => (
                    <div className='user' key={user.id}>
                        <>
                            <Link to={`/user/${user.id}`} className='fioUser'>{user.lastname} {user.firstname} {user.surname}</Link>
                            <a className='emailUser' href={`mailto:${user.email}`}>{user.email}</a>
                            <a className='regionUser'>{user.region}</a>
                            {user.me == true ? (
                            <>
                                <a className='roleUser' style={{display: 'flex', flexDirection: 'column'}}>
                                    <select value="Недоступно" style={{cursor: 'default'}} disabled>
                                        <option value="Недоступно" disabled>Недоступно</option>
                                    </select>
                                    <p>Вы не можете изменить тип своей учётной записи.</p>
                                </a>
                                <a className='statusUser' style={{borderBottom: 'none', borderRight: 'none', display: 'flex', flexDirection: 'column'}}>
                                    <button type='button' className='button maxWidth unactive' onClick={() => openModal('Сообщение', warningChangeStatus)}>Отозвать доступ</button>
                                </a>
                            </>
                            ) 
                            : 
                            (<>
                                <a className='roleUser' style={{display: 'flex', flexDirection: 'column'}}>
                                    <select value={user.role} onChange={(e) => changeRole(e, user.id)} required>
                                        <option value="" disabled>Изменить тип аккаунта</option>
                                        <option value="Арбитражный управляющий">Арбитражный управляющий</option>
                                        <option value="Администратор">Администратор</option>
                                        <option value="Менеджер">Менеджер</option>
                                        <option value="Работник по назначениям">Работник по назначениям</option>
                                        <option value="Работник по жалобам">Работник по жалобам</option>
                                        <option value="Работник по общим">Работник по общим</option>
                                    </select>
                                    <p>Нажмите и выберите нужный тип учетной записи для изменения</p>
                                </a>
                                <a className='statusUser' style={{borderBottom: 'none', borderRight: 'none', display: 'flex', flexDirection: 'column'}}>
                                    <button type='button' className='button maxWidth' onClick={() => changeAccess(user.id)}>Отозвать доступ</button>
                                </a>
                            </>
                            )}
                        </>
                    </div>
                ))}
                {visibilityBtn && <span style={{display: 'flex', justifyContent: 'center'}}><button type='button' className='button' onClick={() => {setLimitForView(prev => prev + 20); setReload(true)}}>Загрузить ещё</button></span>}
            </div>
        </>
    )
}

export default AllUsersTable;